import {
  REQUEST_FETCH_CABINS_INFORMATION_BY_CRUISE,
  FETCH_CABINS_INFORMATION_BY_CRUISE_SUCCESS,
  FETCH_CABINS_INFORMATION_BY_CRUISE_ERROR,
} from "../../../actions/reservations/cabin/fetchCabinsInformationByCruise";

const initialState = {
  cabins: [],
  fetching: false,
  message: "",
  error: "",
};

const cabinInformationByCruiseReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FETCH_CABINS_INFORMATION_BY_CRUISE: {
      return {
        ...state,
        cabins: [],
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_CABINS_INFORMATION_BY_CRUISE_SUCCESS: {
      return {
        ...state,
        cabins: action.cabins,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_CABINS_INFORMATION_BY_CRUISE_ERROR: {
      return {
        ...state,
        cabin: [],
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default cabinInformationByCruiseReducer;
